"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reason = void 0;
var Reason;
(function (Reason) {
    Reason[Reason["CONTENT_NOT_AVAILABLE"] = 0] = "CONTENT_NOT_AVAILABLE";
    Reason[Reason["CONTENT_NOT_AVAILABLE_IN_LOCATION"] = 1] = "CONTENT_NOT_AVAILABLE_IN_LOCATION";
    Reason[Reason["CONTENT_NOT_FOUND"] = 2] = "CONTENT_NOT_FOUND";
    Reason[Reason["ERROR_OCCURED"] = 3] = "ERROR_OCCURED";
})(Reason = exports.Reason || (exports.Reason = {}));
//# sourceMappingURL=constants.js.map